// @flow
import { ATTEMPT_LOAD_TRANSLATIONS, LOAD_TRANSLATIONS } from './constants';

import { createAction } from 'redux-actions';

export const attemptLoadTranslations = createAction(ATTEMPT_LOAD_TRANSLATIONS);
export const loadTranslations = createAction(LOAD_TRANSLATIONS);



// WEBPACK FOOTER //
// ./src/core/state/translations/actions.js